<mat-card style="width: min-content; max-width: 100%;">
    <mat-card-header>
        <div class="g-just-flex flex-between w-100 flex-wrap gap-20">
            <div class="left">
                <mat-card-title>Consultation Requests</mat-card-title>
                <mat-card-subtitle>
                    Service requests assigned to you for consultation.
                </mat-card-subtitle>
            </div>
        </div>
    </mat-card-header>

    <mat-card-content class="my-12">
        <mat-divider></mat-divider>

        <div class="table-or-empty" style="background-color: transparent;">
            @if(tableDataSource.data && tableDataSource.data.length > 0){
            <mat-divider></mat-divider>
            <table style="min-width: 720px; width: unset" mat-table [dataSource]="tableDataSource.data"
                class="mat-elevation-z8 demo-table">

                <ng-container matColumnDef="authoredOn">
                    <th mat-header-cell *matHeaderCellDef>Authored</th>
                    <td mat-cell *matCellDef="let row">
                        @if(row['authoredOn']){
                        <div class="top pt-6">
                            {{ row['authoredOn'] | date:'mediumDate' }}
                        </div>
                        <div class="bottom pb-6 subtitle-text-color-2">
                            {{ row['authoredOn'] | date: 'mediumTime' }}
                        </div>
                        } @else {
                        N/A
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef>Status</th>
                    <td mat-cell *matCellDef="let row">
                        <div [appChips]="row.status" [fontSize]="'14px'"></div>
                    </td>
                </ng-container>

                <ng-container matColumnDef="category">
                    <th mat-header-cell *matHeaderCellDef>Category</th>
                    <td mat-cell *matCellDef="let row">
                        @if(row['category'] && row['category'].length > 0) {
                        <span class="restrict-length">{{ row['category'][0] | codeableConcept2 | na }}</span>
                        } @else {
                        <div>N/A</div>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="code">
                    <th mat-header-cell *matHeaderCellDef>Code</th>
                    <td mat-cell *matCellDef="let row">
                        <span class="restrict-length">{{ row['code'] | codeableConcept2 | na }}</span>
                    </td>
                </ng-container>

                <ng-container matColumnDef="subject">
                    <th mat-header-cell *matHeaderCellDef>Subject</th>
                    <td mat-cell *matCellDef="let row">
                        @if(row.hasSharedDocument) {
                        <span>{{ row.subject?.display || row.subject?.reference || 'Shared patient' }}</span>
                        } @else {
                        <span [appReferenceDisplay]="row.subject?.reference" [instantFetchAndReplace]="true"></span>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="appointment">
                    <th mat-header-cell *matHeaderCellDef>Appointment</th>
                    <td mat-cell *matCellDef="let row">
                        @if(row.linkedAppointment) {
                        <div class="g-just-flex flex-column gap-6">
                            <div [appChips]="appointmentStatusLabel(row)" [fontSize]="'14px'"></div>
                            @if(row.linkedAppointment.start) {
                            <small class="subtitle-text-color-2">{{ row.linkedAppointment.start | date:'medium'
                                }}</small>
                            }
                        </div>
                        } @else {
                        <span class="subtitle-text-color-2">Awaiting booking</span>
                        }
                    </td>
                </ng-container>

                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let row">
                        @if(canOpenPatientSummary(row)) {
                        <button mat-icon-button (click)="openPatientSummary(row, $event)"
                            matTooltip="Open patient summary">
                            <mat-icon>person_search</mat-icon>
                        </button>
                        }
                        @if(canRespondToLinkedAppointment(row)) {
                        <button mat-icon-button (click)="acceptLinkedAppointment(row, $event)"
                            matTooltip="Accept linked appointment">
                            <mat-icon>check_circle</mat-icon>
                        </button>
                        <button mat-icon-button (click)="declineLinkedAppointment(row, $event)"
                            matTooltip="Decline linked appointment">
                            <mat-icon>cancel</mat-icon>
                        </button>
                        }
                        @if(row.linkedAppointment) {
                        <button mat-icon-button (click)="openLinkedAppointment(row, $event)"
                            matTooltip="Open linked appointment">
                            <mat-icon>event</mat-icon>
                        </button>
                        }
                        @if(row.hasSharedDocument) {
                        <button mat-icon-button (click)="openRequestDocument(row); $event.stopPropagation()"
                            matTooltip="Open shared document">
                            <mat-icon>description</mat-icon>
                        </button>
                        }
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="displayedColumns" matHeaderRowDefSticky="true"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="openRow(row)"
                    [style.cursor]="row.hasSharedDocument ? 'pointer' : 'default'"></tr>
            </table>
            } @else {
            <div class="g-just-flex flex-column align-items-center py-40" style="text-align:center;">
                <app-empty-state [icon]="'assignment'" [title]="'No Consultation Requests'"
                    [subtitle]="'No service requests requiring your consultation were found.'">
                </app-empty-state>
            </div>
            }
        </div>
    </mat-card-content>
</mat-card>